import { defineComponent } from "vue";
import VideoList from "@/components/video-list/videoList.vue";
export default defineComponent({
  name: "SVideo",
  props: {
    videoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inputValue: {
      type: String,
      default: ""
    }
  },
  setup: function setup() {
    return {};
  },
  components: {
    VideoList: VideoList
  }
});